export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14949.b90401e7.jpg";